import storage from './storage';

type CxenseProperties = {
	id: string
	segments: Array<string>
	marketingSegments: Array<string>
}

export function getCxenseProperties(): CxenseProperties | null {
	return {
		'id': storage.get('_cX_G'),
		'segments': storage.getArray('cxSegments'),
		'marketingSegments': storage.getArray('cxSegments_m')
	};
}
